<template>
    <vs-popup class="add-new-incoterms" id="popup" :title="`MQL to SAL assessment ${company_name ? company_name : ''}`"
        @close="open = false" :active.sync="open" :buttons-hidden="true">
        <vx-card no-shadow>
            <ValidationObserver ref="form" v-slot="{ handleSubmit }">
                <form id="create-marketing-lead-popup" autocomplete="off">
                    <!-- 
                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="type" name="type" rules="required" v-slot="{ errors }">
                                <small class="label">Status (system)</small>
                                <v-select :clearable="false" placeholder="" v-model="form.status"
                                    :options="['Pending', 'Suspect', 'Influencer', 'Junk']" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div> -->

                    <div class="vx-row mb-4" v-if="!company_name">
                        <div class="vx-col w-full">
                            <vs-alert color=danger class="h-16">
                                The company name is missing. Please add.
                            </vs-alert>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="budget" name="budget" rules="" v-slot="{ errors }">
                                <small class="label">Budget/Forecast</small>
                                <div class="vx-row">
                                    <div class="vx-col w-2/5">
                                        <vs-input v-model="form.budget" name="budget" class="w-full" label=""
                                            :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                            val-icon-pack="feather" />
                                    </div>
                                    <div class="vx-col w-1/5">
                                        <vx-tooltip class="mr-2" text="Refresh Budget/Forecast Value" position="top">
                                            <vs-button @click.stop="calculateMonetaryValue()" class="w-full"
                                                icon-pack="feather" icon="icon-rotate-cw" color="warning"></vs-button>
                                        </vx-tooltip>
                                    </div>
                                    <div class="vx-col w-2/5">
                                        <vs-button @click.stop="onClickUpdateForecast()" class="w-full">Update
                                            Forecast</vs-button>
                                    </div>
                                </div>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="authority" name="authority" rules="" v-slot="{ errors }">
                                <small class="label">Authority</small>
                                <vs-input v-model="form.authority" name="authority" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="need" name="need" rules="" v-slot="{ errors }">
                                <small class="label">Need</small>
                                <vs-input v-model="form.need" name="need" class="w-full" label="" :danger="!!errors[0]"
                                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="timescale" name="timescale" rules="" v-slot="{ errors }">
                                <small class="label">Timescale type</small>
                                <v-select name="timescale_type" :closeOnSelect="true" :clearable="false"
                                    v-model="form.timescale_type" :options="['weeks', 'months']"
                                    :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                            </ValidationProvider>
                        </div>
                        <div class="w-full vx-col md:w-1/2 md:mb-0">
                            <ValidationProvider vid="timescale" name="timescale" rules="max_number:999" v-slot="{ errors }">
                                <small class="label">Timescale</small>
                                <vs-input v-model="form.timescale" name="timescale" class="w-full" label=""
                                    :danger="!!errors[0]" :danger-text="errors[0]" val-icon-danger="icon-x"
                                    val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="reason" name="reason" rules="required" v-slot="{ errors }">
                                <small class="label">Reason for advancing to opportunity</small>
                                <vs-input v-model="form.reason" name="reason" class="w-full" label="" :danger="!!errors[0]"
                                    :danger-text="errors[0]" val-icon-danger="icon-x" val-icon-pack="feather" />
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="role_id" name="role_id"
                                :rules="form.status === 'Accepted' ? 'required' : ''" v-slot="{ errors }">
                                <small class="label">Customer Role</small>
                                <v-select name="role_id" label="name" :closeOnSelect="true" :reduce="option => option.id"
                                    v-model="form.role_id" :options="roles" :dir="$vs.rtl ? 'rtl' : 'ltr'" />
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row mb-3">
                        <div class="w-full vx-col md:w-full md:mb-0">
                            <ValidationProvider vid="account_currency" name="account_currency"
                                :rules="form.status === 'Accepted' ? 'required' : ''" v-slot="{ errors }">
                                <small class="label">Currency</small>
                                <v-select :clearable="false" label="code" v-model="form.account_currency"
                                    :reduce="option => option.code" :options="currencies" :dir="$vs.rtl ? 'rtl' : 'ltr'">
                                    <template v-slot:option="option">
                                        <span>{{ option.code }} - {{ option.name }} </span>
                                    </template>
                                </v-select>
                                <span class="text-danger text-sm">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>


                    <div class="mb-3 vx-row">
                        <div class="w-full vx-col">
                            <ValidationProvider vid="system_comment" name="system_comment" rules="" v-slot="{ errors }">
                                <small class="label">Comments</small>
                                <vs-textarea class="mb-0" v-model="form.comment" height="150px" />
                                <span class="mt-0 text-xs text-danger">{{ errors[0] }}</span>
                            </ValidationProvider>
                        </div>
                    </div>

                    <div class="vx-row" v-if="!!company_name">
                        <div class="vx-col w-1/5">
                            <vx-tooltip class="mr-2" text="Save Draft" position="top">
                                <vs-button @click.stop="onClickSaveDraft" class="mt-2 w-full" color="warning"
                                    icon-pack="feather" icon="icon-save"></vs-button>
                            </vx-tooltip>
                        </div>
                        <div class="vx-col w-2/5">
                            <vs-button @click.stop="onClickSave('Closed NIO')" class="mt-2 w-full" color="danger">
                                Closed - NIO
                            </vs-button>
                        </div>
                        <div class="vx-col w-2/5">
                            <vs-button @click.stop="onClickSave('Accepted')" class="mt-2 w-full">
                                Convert to opportunity
                            </vs-button>
                        </div>
                    </div>
                </form>
            </ValidationObserver>
        </vx-card>
        <UpdateForecast ref="updateForecast" @refreshData="refreshData" />
    </vs-popup>
</template>
  
<script>
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const CrmRepository = RepositoryFactory.get('crm');
const CustomerRepository = RepositoryFactory.get('customer');
const StaffRepository = RepositoryFactory.get('staff');

import vSelect from 'vue-select'

import SuccessMessage from '@/mixins/SuccessMessage'
import ErrorMessages from '@/mixins/ErrorMessages'

import UpdateForecast from "@/components/popups/forecast-tool/UpdateForecast";


function initialState() {
    return {
        open: false,
        id: '',
        form: {
            status: '',
            role_id: null,
            account_currency: null,
            timescale_type: 'weeks',
            budget: "0.00"
        },
        roles: [],
        currencies: [],
        company_name: '',
        lead_data: {}
    }
}

export default {
    name: 'CreateBantPopUp',
    data() {
        return initialState()
    },
    methods: {
        async openPopup(id, company_name = '', lead_data) {
            try {
                await Object.assign(this.$data, initialState());
                await this.$refs.form.reset();
                this.open = true;
                const storedData = localStorage.getItem(`bant_process_data_${id}`);
                if (storedData) {
                    const data = JSON.parse(storedData);
                    this.form = data
                }
                this.fetchRoles()
                this.loadCurrencies()
                this.id = id
                this.lead_data = lead_data
                this.company_name = company_name
                await this.calculateMonetaryValue()
            } catch (error) {

            }
        },
        async refreshData() {
            await this.calculateMonetaryValue()
        },
        async onClickCreateSite() {
            const vue = this;
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                let payload = {}
                Object.assign(payload, this.form)
                if (this.form.status === 'Closed NIO') {
                    delete payload.role_id
                    delete payload.account_currency
                }
                payload.budget = Number(payload.budget).toFixed(0)
                await CrmRepository.createBantForMarketingLead(this.id, payload);
                this.showSuccessMessage('BANT created successfully');

                //removed drafted data
                localStorage.removeItem(`bant_process_data_${this.id}`);

                this.open = false;
                await vue.$parent.refreshData();
            } catch (e) {
                this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
                this.convertAndNotifyError(e)
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async fetchRoles() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            const { data } = (await CustomerRepository.getCustomerRoles()).data
            this.roles = data
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async loadCurrencies() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            const { data } = (await StaffRepository.getCurrencyList()).data
            this.currencies = data
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async onClickSave(status) {
            this.form.status = status
            const validated = await this.$refs.form.validate().then((x) => {
                return x
            })
            if (validated) {
                this.onClickCreateSite()
            }
        },
        async calculateMonetaryValue() {
            await this.$vs.loading({
                container: '#create-marketing-lead-popup',
                scale: 0.45
            })
            try {
                const payload = {
                    'customer-lead-id': this.id,
                }
                const { data } = (await CrmRepository.getOpportunityValueFromForecaseTool(payload)).data
                this.form.budget = data.value
            } catch (error) {
                this.form.budget = "0.00"
            }
            this.$vs.loading.close('#create-marketing-lead-popup > .con-vs-loading')
        },
        async onClickUpdateForecast() {
            // this.open = !this.open
            // await this.$parent.onClickViewForecast(this.id);
            await this.$refs.updateForecast.openPopup({ data: this.lead_data, customer_type: 'lead' })
        },
        onClickSaveDraft() {
            localStorage.setItem(`bant_process_data_${this.id}`, JSON.stringify(this.form))
            this.open = !this.open
        }
    },
    components: {
        'v-select': vSelect,
        UpdateForecast
    },
    mixins: [SuccessMessage, ErrorMessages],
}
</script>
  
<style scoped>
.add-new-incoterms>>>.vs-popup {
    /*min-height: 50% !important;*/
    min-width: 30% !important;
}
</style>
  